import { useQuery } from "@tanstack/react-query"
import { fetchCategories } from "./CategoryApi"



export function useCategories() {
    return useQuery(
        {
            queryKey: ['categories'],
            queryFn: fetchCategories
        }
    )
}
